import { render, staticRenderFns } from "./StudyInstitutes.vue?vue&type=template&id=27489e04&scoped=true"
import script from "./StudyInstitutes.vue?vue&type=script&lang=ts"
export * from "./StudyInstitutes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27489e04",
  null
  
)

export default component.exports